import { type Ref, computed, unref } from "vue";

import { useQuery } from "@tanstack/vue-query";

import { ONE_MINUTE_MS } from "@/helpers/constants";
import { QUERY_KEYS } from "@/helpers/constants/queryKeys";
import UnderwritingApiService from "@/services/modules/underwriting";

import type { IUnderwritingLog } from "@/models/underwriting";

export const useUnderwritingLogsQuery = (applicationId: Ref<string>) => {
  const id = computed(() => unref(applicationId));

  return useQuery({
    queryKey: computed(() => QUERY_KEYS.UNDERWRITING.logs(id.value)),
    queryFn: async (): Promise<IUnderwritingLog[]> => {
      const response = await UnderwritingApiService.getLogs(id.value);
      return response.data;
    },
    enabled: computed(() => !!id.value?.trim()),
    staleTime: 5 * ONE_MINUTE_MS,
    gcTime: 10 * ONE_MINUTE_MS,
  });
};
